'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.URL = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _class, _temp;

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var URL = exports.URL = (_temp = _class = function URL() {
  (0, _classCallCheck3.default)(this, URL);
}, _class.removeUnusedParam = function () {
  if (window.history.pushState) {
    var uri = _url2.default.parse(window.location.href, true);
    uri.search = '';
    delete uri.query.token; // For Secure Token
    delete uri.query.operatorToken; // For SSO Token
    delete uri.query.operator_id;
    var newUrl = _url2.default.format(uri);
    window.history.pushState({ path: newUrl }, '', newUrl);
  }
}, _class.getUnDecodedQueryVariable = function (variable) {
  var query = _url2.default.parse(window.location.href, false).query;
  var vars = query.split('&');
  for (var index = 0; index < vars.length; index += 1) {
    var pair = vars[index].split('=');
    if (decodeURIComponent(pair[0]) === variable) {
      return pair[1];
    }
  }
  return '';
}, _class.getHashParams = function () {
  return URL.getParams(window.location.hash);
}, _class.getParams = function (value) {
  return value.substr(1).split('&').reduce(function (obj, item) {
    var split = item.split('=');
    obj[split[0]] = split[1];
    return obj;
  }, {});
}, _class.toUrlParameter = function (obj) {
  return (0, _keys2.default)(obj).filter(function (key) {
    return obj[key] !== undefined && obj[key] !== null;
  }).reduce(function (prev, key, index) {
    return '' + prev + (index !== 0 ? '&' : '') + key + '=' + obj[key];
  }, '?');
}, _temp);


//////////////////
// WEBPACK FOOTER
// ./src/helpers/URL.js
// module id = 416
// module chunks = 0